import { ReactNode, useState } from "react";
import { Box, Flex } from "@chakra-ui/react";
import Sidebar from "../components/Sidebar";

interface DashboardLayoutProps {
  children: ReactNode;
}

const DashboardLayout = ({ children }: DashboardLayoutProps) => {
  const [collapsed, setCollapsed] = useState(true);

  return (
    <Flex height="100vh">
      <Sidebar collapsed={collapsed} onToggleCollapse={() => setCollapsed(!collapsed)} />
      <Box as="main" flex="1" p={6} overflow="auto" bg="gray.50">
        {children}
      </Box>
    </Flex>
  );
};

export default DashboardLayout;
